// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z_37r","controls":"styles_controls__1AM3z","charLimit":"styles_charLimit__1v2Eg","input":"styles_input__1NULH","send":"styles_send__kgCfz"};